import { render } from "./InitialSetupBanner.vue?vue&type=template&id=06afdc76&scoped=true"
import script from "./InitialSetupBanner.vue?vue&type=script&lang=js"
export * from "./InitialSetupBanner.vue?vue&type=script&lang=js"

import "./InitialSetupBanner.vue?vue&type=style&index=0&id=06afdc76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06afdc76"]])

export default __exports__